import useCustomerGroups from "./useCustomerGroups";

export const useCustomerGroupById = (customerGroupId: number) => {
    const customerGroups = useCustomerGroups();

    return customerGroups.find(({ id }) => id === customerGroupId);
};
